import { createTheme as o } from "./ghl-ui.es855.js";
import n from "./ghl-ui.es1157.js";
import r from "./ghl-ui.es1179.js";
import m from "./ghl-ui.es1160.js";
function c(e) {
  const {
    boxShadow2: t
  } = e;
  return {
    menuBoxShadow: t
  };
}
const i = o({
  name: "Select",
  common: n,
  peers: {
    InternalSelection: r,
    InternalSelectMenu: m
  },
  self: c
}), f = i;
export {
  f as default,
  c as self
};
